import styled from 'styled-components';

export const Label = styled.label`
  &&& {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-radius: 4px;
    padding: 12px 12px 12px 65px;
    cursor: pointer;
    &:before {
      background: #edf0f1;
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      content: '';
      display: block;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      box-sizing: border-box;
    }
    &:after {
      z-index: 99;
      position: absolute;
      top: 48%;
      left: 20px;
      transform: translateY(-50%) rotate(-45deg);
      content: '';
      display: block;
      width: 16px;
      height: 8px;
      border-left: solid 3px #0066ff;
      border-bottom: solid 3px #0066ff;
    }
  }
`;

export const Input = styled.input`
  &&& {
    display: none;
    &:checked + ${Label} {
      &:before {
        background: #0066ff;
        border: none;
      }
      &:after {
        z-index: 99;
        position: absolute;
        top: 48%;
        left: 20px;
        transform: translateY(-50%) rotate(-45deg);
        content: '';
        display: block;
        width: 16px;
        height: 8px;
        border-left: solid 3px #fff;
        border-bottom: solid 3px #fff;
      }
    }
  }
`;

export const Textarea = styled.textarea`
  &&& {
    width: 100%;
    border: 1px solid #d8d8d8;
    background: #fff;
  }
`;
